import { TRIMMED_INPUT_REGEX } from 'constants/constants';
import { EPopupSubType, OfferType } from 'constants/enums';
import { z } from 'zod';

export const REWARD_CALENDAR_TIMEZONES = ['UTC', 'EST', 'PST', 'CET'] as const;
export type RewardCalendarTimeZone = (typeof REWARD_CALENDAR_TIMEZONES)[number];

export const REWARD_CALENDAR_TIMEZONE_OPTIONS = REWARD_CALENDAR_TIMEZONES.map(
  (tz) => ({ content: tz, key: tz, value: tz, label: tz })
);

export const REWARD_CALENDAR_SCHEMA = z.object({
  _id: z.string().optional(),
  active: z.boolean(),
  name: z
    .string()
    .min(1, 'Name is required')
    .refine((value) => TRIMMED_INPUT_REGEX.test(value), {
      message: 'Name should not be spaces'
    }),
  subType: z.nativeEnum(EPopupSubType),
  publisherOfferId: z
    .string()
    .min(1, 'External ID is required')
    .refine((value) => TRIMMED_INPUT_REGEX.test(value), {
      message: 'External ID should not be spaces'
    }),
  offerUiId: z.string().min(1, 'Offer Design is required'),
  priority: z.number({ required_error: 'Priority is required' }).min(1),
  startOver: z.boolean(),
  segments: z.array(z.string()),
  startTimeZone: z.enum(REWARD_CALENDAR_TIMEZONES, {
    required_error: 'Time Zone is required'
  }),
  startTime: z.date({
    required_error: 'Start Time is required',
    invalid_type_error: 'Start Time is required'
  }),
  type: z.nativeEnum(OfferType),
  productName: z.string().optional(),
  quantity: z.number(),
  products: z.array(z.any()).optional()
});

export type RewardCalendarFormFields = z.infer<typeof REWARD_CALENDAR_SCHEMA>;

const buildDefaultStartTime = (): Date => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
};

export const REWARD_CALENDAR_DEFAULT_VALUES: RewardCalendarFormFields = {
  active: true,
  name: '',
  subType: EPopupSubType.DAILY_BONUS,
  publisherOfferId: '',
  offerUiId: '',
  priority: 1,
  startOver: true,
  segments: [],
  startTimeZone: 'UTC',
  startTime: buildDefaultStartTime(),
  type: OfferType.POPUP,
  productName: '',
  quantity: 1,
  products: []
};
